import React from 'react';

import './ButtonBox.scss';
import { ListFieldItem } from 'RLX/Forms/ListField';

class ButtonBox extends ListFieldItem {
  constructor (props) {
    super(props);
    this.getFields = this.getFields.bind(this);
  }

  getFields () {
    const { item } = this.props;
    const { propertyUpdaterFactory } = this;
    return [
      {
        label: 'Button Text',
        icon: 'font',
        value: item.text,
        type: 'text',
        onChange: propertyUpdaterFactory('text', item)
      },
      {
        label: 'Link to URL',
        icon: 'link',
        type: 'text',
        value: item.url,
        onChange: propertyUpdaterFactory('url', item)
      },
      {
        label: 'Button Style',
        icon: 'cube',
        value: item.type,
        options: [
          { text: 'Download Button', value: 'download' },
          { text: 'Plain Button', value: '' }
        ],
        type: 'select',
        onChange: propertyUpdaterFactory('type', item)
      }
    ];
  }
};

export default ButtonBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ButtonBox/ButtonBox.jsx